import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.originalTitle = this.element.getAttribute('title') || 'Copy link'
    this.tooltip = new bootstrap.Tooltip(this.element)
  }

  disconnect() {
    if (this.tooltip) {
      this.tooltip.dispose()
    }
  }

  copy(event) {
    event.preventDefault()
    event.stopPropagation()

    // Fallback if window.main.copyTextToClipboard is not available
    const textToCopy = this.element.dataset.copyUrl
    if (window.main && typeof window.main.copyTextToClipboard === 'function') {
      window.main.copyTextToClipboard(textToCopy)
    } else {
      navigator.clipboard.writeText(textToCopy)
    }

    this.tooltip.hide()
    this.element.setAttribute('data-bs-original-title', 'Copied!')
    this.tooltip.show()

    setTimeout(() => {
      this.tooltip.hide()
      this.element.setAttribute('data-bs-original-title', this.originalTitle)
    }, 1500)
  }
}
